"use client";

import { cn } from "../../lib/utils";

export type PostStudioHeroCardProps = {
  isActivated: boolean;
  title: string;
  subtitle: string;
  note: string;
  monetizationTitle: string;
  activatedLabel: string;
  className?: string;
};

export function PostStudioHeroCard({
  isActivated,
  title,
  subtitle,
  note,
  monetizationTitle,
  activatedLabel,
  className,
}: PostStudioHeroCardProps) {
  return (
    <section
      className={cn(
        "rounded-2xl border border-black bg-white px-4 py-4 shadow-[0px_4px_0px_0px_#000000]",
        className
      )}
    >
      <div className="space-y-3">
        {isActivated ? (
          <div className="flex items-center justify-between gap-3 rounded-xl bg-[#FCFCFD] px-4 py-3">
            <p className="text-sm font-semibold text-[#344054]">{monetizationTitle}</p>
            <span className="inline-flex items-center gap-2 rounded-full bg-[#ECFDF3] px-3 py-1 text-xs font-semibold text-[#027A48]">
              <span className="inline-block h-2 w-2 shrink-0 rounded-full bg-[#12B76A]" />
              {activatedLabel}
            </span>
          </div>
        ) : (
          <>
            <h1 className="whitespace-nowrap text-xl font-bold leading-[1.1] tracking-[-0.03em] text-[#344054]">
              {title}
            </h1>
            <p className="text-sm leading-6 text-[#667085]">{subtitle}</p>
            <div className="rounded-xl border border-[#FDE7F3] bg-[#FFF8FC] px-4 py-3">
              <p className="text-sm font-semibold leading-6 text-[#ED5AA9]">{note}</p>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

